import { render, staticRenderFns } from "./CustomWheelEditor.vue?vue&type=template&id=fa4024cc&scoped=true&"
import script from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CustomWheelEditor.vue?vue&type=style&index=0&id=fa4024cc&lang=scss&scoped=true&"
import style1 from "./CustomWheelEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4024cc",
  null
  
)

export default component.exports